import { MasterVM } from "./MasterVM";

export class RoleReportConfigurationVM {
    RAC_ID:number   ;
    RAC_R_ID:number   ;
    RAC_RP_ID:number   ;
}